export default {
      id: "scissors-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#scissors",
      toString: function () {
        return this.url;
      }
    }